import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSearchForReview = () => {
  return useMutation(getInvoiceBy);
};
export default useSearchForReview;
